import { CanActivate, Router } from "@angular/router";
import { Injectable, Inject, PLATFORM_ID } from "@angular/core";
import { LoginUsersService } from "./../../Services/login-users.service";
import { isPlatformServer } from "@angular/common";
import { EmbryoService } from "../../Services/Embryo.service";
@Injectable()
export class AuthLoginGuard implements CanActivate {
    lang: any;
    constructor(
        private router: Router,
        public embryoService: EmbryoService,
        private auth: LoginUsersService,
        @Inject(PLATFORM_ID) private platformId: Object
    ) {
        this.embryoService.emitLang.subscribe((lang: any) => {
            this.lang = lang;
        });
    }

    canActivate() {
        if (isPlatformServer(this.platformId)) return true;
        if (!this.auth.isGuest())
            this.router.navigate(["/" + this.lang + "/account/profile"]);
        return true;
    }
}
